import { useEffect } from 'react'
import star from '../../assets/star.svg'
import './Footer.scss'

const stripeData = [
  'Experiențe VIP la evenimentul Refresh Your Music',
  "Experiențe VIP la Nos Alive '25",
  'Multe alte premii'
]

const Footer = ({ isMobile = false }) => {
  useEffect(() => {}, [])
  return (
    <div className={'footer-container' + (isMobile ? '' : ' isDesktop')}>
      <div className={'footer-background'}></div>
      <div className="footer-animated">
        {stripeData.map((text: string) => (
          <div
            key={'stripe-element-' + stripeData.indexOf(text)}
            className={'stripe-element ' + stripeData.indexOf(text)}
          >
            <p>{text}</p>
            <img src={star} alt="star" />
          </div>
        ))}
      </div>
      <div className="footer-fitter">
        {stripeData.map((text: string) => (
          <div
            key={'stripe-element-fitter-' + stripeData.indexOf(text)}
            className={'stripe-element ' + stripeData.indexOf(text)}
          >
            <p>{text}</p>
            <img src={star} alt="star" />
          </div>
        ))}
      </div>
    </div>
  )
}

export default Footer
